var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgECommerce6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 326.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-21,.cls-23,.cls-24,.cls-30,.cls-31,.cls-33,.cls-34,.cls-6{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:#d8c4df;}.cls-4{font-size:70px;}.cls-27,.cls-28,.cls-29,.cls-36,.cls-4,.cls-7{fill:#2f2143;}.cls-25,.cls-27,.cls-28,.cls-29,.cls-4{font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-5{fill:#e7b7b7;}.cls-6{stroke:#565349;stroke-width:0.95px;}.cls-30,.cls-31,.cls-33,.cls-34,.cls-6{stroke-miterlimit:10;}.cls-8{fill:#f9f9fc;}.cls-9{fill:#9e5ca5;}.cls-10{fill:#1f3242;}.cls-11{fill:#966666;}.cls-12{fill:#e3a2a2;}.cls-13{fill:#9cbfe5;}.cls-14{opacity:0.6;}.cls-15{clip-path:url(#clip-path);}.cls-16{fill:#fdc435;}.cls-17{clip-path:url(#clip-path-2);}.cls-18{clip-path:url(#clip-path-3);}.cls-19{clip-path:url(#clip-path-4);}.cls-20{fill:#33144e;}.cls-20,.cls-21,.cls-23,.cls-24{stroke:#231f20;}.cls-20,.cls-21{stroke-width:0.22px;}.cls-22{fill:#231f20;}.cls-23,.cls-24{stroke-width:0.11px;}.cls-23{stroke-dasharray:0.67 0.44;}.cls-25{font-size:16.43px;}.cls-25,.cls-32{fill:#fff;}.cls-26{fill:#9a499c;}.cls-27{font-size:32.89px;}.cls-28{font-size:23.71px;}.cls-29{font-size:26.62px;}.cls-30,.cls-31,.cls-33,.cls-34{stroke:#2f2143;}.cls-30{stroke-width:1.76px;}.cls-31,.cls-34{stroke-linecap:round;}.cls-31{stroke-width:6px;}.cls-33{stroke-width:1.2px;}.cls-34{stroke-width:1.59px;}.cls-35{fill:#8a56a3;}.cls-36{mix-blend-mode:multiply;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.42,
    y: 86.65,
    width: 110.75,
    height: 85.27
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 152.15,
    y: 51.73,
    width: 38.17,
    height: 24.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 302.45,
    y: 96.12,
    width: 85.33,
    height: 56.15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 258.66,
    y: 9.78,
    width: 118.89,
    height: 54.07
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E-Commerce 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 1600,
    height: 326
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(561.75 188.46)"
  }, "E-COMMERCE"), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M334.62,149.88c.29-1.21,2-4.52-2.25-8.39-2.12-1.94-4.95-8.61-5.41-9.39-1.51-2.5-1.83-6.9-2.18-7.87-.16-.43,1.73-2,3.92-.07.87.75,1.52,2,2.23,4.56.37,1.31,2.43,4.34,3.45,4.19,1.29-.18,2.06-.87,2.21-2.64.38-4.51-5.28-19.31-4.7-20.61a2.21,2.21,0,0,1,4.05.34c.65,1.56,2.53,7.39,3.58,7.22.64-.1.44-5.71.2-10.91-.15-3.21,3.53-2.66,3.81-1.15.63,3.3,1.12,6.13,1.58,6.47s.67-2.32.88-3a1.93,1.93,0,0,1,3.71.13c.11.58.92,9.68,2,9.74.73,0,.66-2.91.76-3.21.68-2.13,3.66-1.78,3.6.86,0,2.3-.18,12.27-.36,14.75-.23,3.25-.3,9.62-3.44,23.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M352.26,154.6c-3.24,15.17-5.73,71.56-16,75.42-10.54,4-34.31-12.22-34.31-12.22l11.29-27.66,8.92,6.91c3.07-16.34,12.48-47.17,12.48-47.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M322.14,197.05a52.19,52.19,0,0,0,0,16.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.63,132c5.89,1.92,8.27,8.26,8.27,8.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M339.52,117.22c.77,2.44,1.62,7,1.62,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M345.11,111.63c.78,5.59,1.11,12.56,1.11,12.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M351.7,118.5c.09,1.61,0,6.43,0,6.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155.53,149.88c-.29-1.21-2-4.52,2.25-8.39,2.12-1.94,4.95-8.61,5.42-9.39,1.5-2.5,1.82-6.9,2.17-7.87.16-.43-1.72-2-3.92-.07-.86.75-1.52,2-2.22,4.56-.37,1.31-2.44,4.34-3.46,4.19-1.29-.18-2.06-.87-2.21-2.64-.38-4.51,5.29-19.31,4.7-20.61a2.21,2.21,0,0,0-4,.34c-.66,1.56-2.53,7.39-3.59,7.22-.64-.1-.44-5.71-.2-10.91.15-3.21-3.53-2.66-3.81-1.15-.63,3.3-1.12,6.13-1.58,6.47s-.67-2.32-.88-3a1.93,1.93,0,0,0-3.71.13c-.11.58-.92,9.68-2,9.74-.73,0-.66-2.91-.76-3.21-.68-2.13-3.66-1.78-3.6.86,0,2.3.18,12.27.36,14.75.23,3.25.3,9.62,3.44,23.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.89,154.6c3.24,15.17,5.74,71.56,16,75.42,10.55,4,34.31-12.22,34.31-12.22l-11.29-27.66L168,197.05c-3.07-16.34-12.48-47.17-12.48-47.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M168,197.05a52.19,52.19,0,0,1,0,16.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.52,132c-5.89,1.92-8.26,8.26-8.26,8.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.63,117.22c-.77,2.44-1.62,7-1.62,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145,111.63c-.78,5.59-1.1,12.56-1.1,12.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.45,118.5c-.08,1.61,0,6.43,0,6.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M243.86,326c.8-3.55,1.21-5.27,1.21-5.27s.46,1.74,1.36,5.27c15.28-.14,30.78,0,45.86,0-1.78-22.19-3.66-43.55-3.66-43.55h-87.1s-2.21,20.69-4.21,43.55C212.82,326,228.36,326.15,243.86,326Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M274.85,162.46H215.49v121.9c19.35,5.66,59.36,1.35,59.36,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M261,162.46c.74,8.63-4.28,16.65-15.95,16.65C229,179.11,229,162.46,229,162.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M239.15,183.58c4.31,15.36-1.89,109.13-1.89,109.13-24.25,1-38.41-5.47-38.41-5.47L204.66,210l-20.28,13.68c-8-3.17-13.09-31.14-13.09-31.14s33.21-30.07,44.2-30.07h16.78c-13.6,9.62,6.88,21.12,6.88,21.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M251.19,183.58c-4.31,15.36,1.89,109.13,1.89,109.13,24.25,1,38.41-5.47,38.41-5.47L285.68,210,306,223.67c8-3.17,13.09-31.14,13.09-31.14s-33.21-30.07-44.2-30.07H258.07c13.6,9.62-6.88,21.12-6.88,21.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M232.27,162.46l.6-6.15s-5.84,2.54-8.45,6.15,0,26.69,0,26.69,4.94-7.28,6.56-7.45,8.17,1.88,8.17,1.88-12-14.13-6.88-21.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M258.07,162.46l-.43-6.15s5.67,2.54,8.28,6.15,0,26.69,0,26.69-4.94-7.28-6.56-7.45-8.17,1.88-8.17,1.88,12-14.13,6.88-21.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M285.68,210c-1.33-4.9-2.65-19.73-2.65-19.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M204.66,210c.67-6.58,2.29-21.53,2.29-21.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M216.43,118.94c2.33,7.79,5.2,10.08,11.1,12.5l27.8,11.64c8.2-8.88,9.84-13,9.84-25.05,5.24-10.5-1.64-27.35-12.47-24.12-9.46-15.09-51.77,5.2-36.27,25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M231.89,166.18c.85,2.21,6.05,8.06,12.45,8.06,9.32,0,13.92-7.72,13.92-10.88l-3.41-38.51-19.85,4c.29,2.91-2.24,28.75-3.11,37.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M234.16,142.19l16.08-1.55s-.76,12.88-17.27,14.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M221.25,111.33c-3.85,6.12-1.25,9.44-1.25,15.52,0,6.53-2.5,15.8,2.73,20.63,5.42,5,18,5.24,26.57-5.59s6.7-29.2-2.73-33.91c-8.06-4-20-5.11-25.32,3.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M217.49,118.94c6.95,1,11.18-7.92,18.67-9.7a9.52,9.52,0,0,0,8.21,8.51c6.84,3.28,5.73,12,8.09,12,1.37,0,1.25-5.86,2.44-7.75,4.88-7.78,2-15.87-6.48-19.63s-19-4.94-24.9,0-6,16.56-6,16.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M226.57,136.27c-3,0-3.58-.6-4-1.39-.29-.49,0-1.44.6-3.56a40.32,40.32,0,0,0,1.19-4.6.34.34,0,0,1,.4-.29.35.35,0,0,1,.29.41,43.42,43.42,0,0,1-1.21,4.69,13,13,0,0,0-.7,2.95c.32.53.65,1.09,3.48,1.09a.35.35,0,0,1,.35.35.35.35,0,0,1-.35.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M246.16,128.5a3.33,3.33,0,1,1-4.68-1.76,3.53,3.53,0,0,1,4.68,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M232.41,123.86c0,1.26-.6,2.29-1.35,2.29s-1.35-1-1.35-2.29.61-2.3,1.35-2.3,1.35,1,1.35,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M228.67,119.66c.28,1,2.69-.77,4.1-.63,2.41.24,2.51,1.45,3.38,1.23.12-1.11-1.42-2.52-3.51-2.66a3.79,3.79,0,0,0-4,2.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M222.35,124.85c0,1.05-.5,1.9-1.12,1.9s-1.12-.85-1.12-1.9.5-1.9,1.12-1.9,1.12.85,1.12,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M222.9,121c0,.75-2,0-2.91.37-1.47.64-1.51,1.82-1.92,1.64a2.36,2.36,0,0,1,1.59-2.68,2.86,2.86,0,0,1,3.24.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M234,137a16.94,16.94,0,0,1-6.68,3.63s2.68,1.69,5.1,1.28S234,137,234,137"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M254.9,122a4.76,4.76,0,0,1,8.39,1.73c.79,2.7,0,10.32-7.66,9.8,0,0-2.5-9.24-.73-11.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M256,129.28h.1a.42.42,0,0,0,.3-.51c-.49-2,0-4.16,1.24-5a2,2,0,0,1,2.38.17.42.42,0,0,0,.47-.7,2.82,2.82,0,0,0-3.33-.16c-1.49,1-2.15,3.51-1.57,5.88a.43.43,0,0,0,.41.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M189,128a4.62,4.62,0,0,0-4.52-4.15,3.75,3.75,0,0,0-3.8,4.15,4.63,4.63,0,0,0,4.53,4.16A3.75,3.75,0,0,0,189,128"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M190.23,142.19A4.64,4.64,0,0,0,185.7,138a3.74,3.74,0,0,0-3.79,4.16,4.62,4.62,0,0,0,4.52,4.16,3.75,3.75,0,0,0,3.8-4.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M187.74,113.76a3.75,3.75,0,0,1-3.8,4.16,4.63,4.63,0,0,1-4.52-4.16,3.75,3.75,0,0,1,3.79-4.16,4.63,4.63,0,0,1,4.53,4.16"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M192.38,171.91H96a3.8,3.8,0,0,1-3.78-3.46L85.44,90.77a3.79,3.79,0,0,1,3.78-4.12h96.36a3.79,3.79,0,0,1,3.78,3.46l6.8,77.68a3.79,3.79,0,0,1-3.78,4.12"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "184.53 57.46 172.05 57.46 171.96 56.42 184.44 56.42 184.53 57.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "177.44 59.66 172.25 59.66 172.16 58.62 177.35 58.62 177.44 59.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "184.92 61.86 172.44 61.86 172.35 60.82 184.82 60.82 184.92 61.86"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M157.4,75.94h29.13a3.8,3.8,0,0,0,3.78-4.13L188.85,55.2a3.8,3.8,0,0,0-3.78-3.47H156a3.79,3.79,0,0,0-3.78,4.13l1.45,16.62a3.79,3.79,0,0,0,3.78,3.46"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M167.92,68.76c.24,2.72-2,3.41-4.9,3.41s-5.26-.69-5.5-3.41a4.57,4.57,0,0,1,4.77-4.91,5.64,5.64,0,0,1,5.63,4.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M164.76,58.62a3.47,3.47,0,0,0-3.39-3.12,2.82,2.82,0,0,0-2.85,3.12,3.47,3.47,0,0,0,3.39,3.12,2.81,2.81,0,0,0,2.85-3.12"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M379.73,152.27H306.24a3.8,3.8,0,0,1-3.78-4.13l4.25-48.56a3.8,3.8,0,0,1,3.78-3.46H384a3.78,3.78,0,0,1,3.78,4.12l-4.25,48.56a3.8,3.8,0,0,1-3.78,3.47"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M371.32,63.85H262.46a3.79,3.79,0,0,1-3.79-4l2.43-46.48a3.8,3.8,0,0,1,3.79-3.6H373.75a3.79,3.79,0,0,1,3.79,4l-2.43,46.48a3.8,3.8,0,0,1-3.79,3.59"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M126.7,102s-5.41,3.15-7,3.79-3.73,1.29-4.69,2.58-3.93,5-4.89,6.24-4.12,4.56-4.12,4.56a19.16,19.16,0,0,1,2.25,2.58c.71,1.09,4.57,3.92,6.24,5.08a23,23,0,0,1,1.1-2.83,25.8,25.8,0,0,1,.7,4c.07,1.48.07,8.75.2,11.38s.45,4.7.64,8.05.06,8.1.06,8.1,6.44.2,8.5.07a77.33,77.33,0,0,1,9.78-.45c3.73.19,8.36.64,9.77.58s4.38-.33,4.38-.33-.26-6.11-.13-8.81.45-6.5.51-8.81-.06-9.14-.19-10.55-.19-4.12-.19-4.12a26.55,26.55,0,0,1,1.93,3.47,20.57,20.57,0,0,0,4.18-3.41c1-.9,3.15-2.44,3.15-2.44s-2.7-3.48-3.6-4.83-3.6-4.69-4.25-6-1.41-1.54-3-2.57-8.23-5.21-8.23-5.21l-2.51.57-6.31.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M137.44,103.36a8.84,8.84,0,0,1-1.16,2.12c-.64.77-2.31,1.29-4.18,1.16s-3.47-2.32-3.86-3.48C132.16,104,135.12,104,137.44,103.36Zm-9.59-2.45-1.67,1.23a6.23,6.23,0,0,0,1.29,3.28c1.28,1.8,3.34,3.15,5.34,3s4.63-1.54,5.21-2.44a37.25,37.25,0,0,0,1.74-3.86L138.34,101a14.32,14.32,0,0,1-5.92.9A9.13,9.13,0,0,1,127.85,100.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M115.57,124c.7-1.67,1.93-4.57,1.86-6.37s-.71-9.33-.9-10.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M149.6,123.11a23.48,23.48,0,0,1-1.74-7.66,30.25,30.25,0,0,1,.45-7.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M120.2,105.61c1-.5,2-.93,3-1.36s2-.82,3.07-1.15c-1,.5-2,.93-3,1.36S121.24,105.28,120.2,105.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M139.43,103.16c1.2.45,2.36,1,3.52,1.48s2.31,1.07,3.43,1.68c-1.19-.44-2.35-1-3.52-1.48S140.55,103.77,139.43,103.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M128.24,103.16a7.51,7.51,0,0,1-.39-2.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M137.44,103.36c.26-.77.64-1.42.9-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M106.56,118.48c1.09.9,2.64,3.34,3.28,3.92a38.38,38.38,0,0,0,4.89,3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M106.88,118.22c1.09.9,2.64,3.34,3.28,3.92a38,38,0,0,0,4.89,3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M151.08,125.49a22,22,0,0,0,4.12-3.15,11.45,11.45,0,0,1,3-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M150.89,125.17A21.38,21.38,0,0,0,155,122a12.12,12.12,0,0,1,3-2.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 126.56,
    y1: 102.41,
    x2: 127.55,
    y2: 101.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 126.71,
    y1: 103.04,
    x2: 127.58,
    y2: 102.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 127.71,
    y1: 102.96,
    x2: 126.87,
    y2: 103.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 127.97,
    y1: 103.56,
    x2: 127.05,
    y2: 104.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 128.18,
    y1: 103.9,
    x2: 127.4,
    y2: 104.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 128.42,
    y1: 104.37,
    x2: 127.79,
    y2: 104.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 128.63,
    y1: 104.79,
    x2: 128.03,
    y2: 105.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 128.92,
    y1: 105.08,
    x2: 128.29,
    y2: 105.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 129.16,
    y1: 105.48,
    x2: 128.66,
    y2: 106.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 129.52,
    y1: 105.79,
    x2: 128.97,
    y2: 106.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 129.86,
    y1: 106.11,
    x2: 129.31,
    y2: 106.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 130.29,
    y1: 106.45,
    x2: 129.76,
    y2: 107.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 130.63,
    y1: 106.58,
    x2: 130.23,
    y2: 107.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 131.1,
    y1: 106.74,
    x2: 130.78,
    y2: 107.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 131.49,
    y1: 106.87,
    x2: 131.31,
    y2: 107.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 132.1,
    y1: 107.05,
    x2: 131.99,
    y2: 107.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 132.75,
    y1: 107.05,
    x2: 132.78,
    y2: 108.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 133.23,
    y1: 107,
    x2: 133.38,
    y2: 107.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 133.8,
    y1: 106.95,
    x2: 133.96,
    y2: 107.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 134.33,
    y1: 106.84,
    x2: 134.57,
    y2: 107.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 134.91,
    y1: 106.69,
    x2: 135.2,
    y2: 107.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 135.49,
    y1: 106.48,
    x2: 135.88,
    y2: 107.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 136.01,
    y1: 106.19,
    x2: 136.54,
    y2: 106.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 136.51,
    y1: 105.77,
    x2: 137.11,
    y2: 106.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 136.85,
    y1: 105.35,
    x2: 137.67,
    y2: 105.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 137.22,
    y1: 104.79,
    x2: 137.93,
    y2: 105.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 137.43,
    y1: 104.24,
    x2: 138.22,
    y2: 104.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 137.72,
    y1: 103.67,
    x2: 138.48,
    y2: 104.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 137.93,
    y1: 103.06,
    x2: 138.58,
    y2: 103.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 138.11,
    y1: 102.56,
    x2: 138.95,
    y2: 103.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 138.37,
    y1: 101.98,
    x2: 139.16,
    y2: 102.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 128.42,
    y1: 101.62,
    x2: 128.32,
    y2: 102.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 128.87,
    y1: 101.8,
    x2: 128.66,
    y2: 102.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 129.39,
    y1: 101.93,
    x2: 129.26,
    y2: 102.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 129.97,
    y1: 102.06,
    x2: 129.81,
    y2: 103.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 130.47,
    y1: 102.22,
    x2: 130.39,
    y2: 103.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 131.02,
    y1: 102.27,
    x2: 130.92,
    y2: 103.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 131.57,
    y1: 102.38,
    x2: 131.57,
    y2: 103.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 132.23,
    y1: 102.35,
    x2: 132.2,
    y2: 103.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 132.73,
    y1: 102.41,
    x2: 132.81,
    y2: 103.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 133.36,
    y1: 102.41,
    x2: 133.46,
    y2: 103.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 133.91,
    y1: 102.41,
    x2: 134.09,
    y2: 103.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 134.59,
    y1: 102.35,
    x2: 134.83,
    y2: 103.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 135.28,
    y1: 102.22,
    x2: 135.77,
    y2: 103.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 136.06,
    y1: 102.17,
    x2: 136.38,
    y2: 103.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 136.75,
    y1: 101.98,
    x2: 137.09,
    y2: 102.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 137.32,
    y1: 101.77,
    x2: 137.48,
    y2: 102.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M327.48,34.94l-44,18.94s-4-7.52,3.52-12.18c8.05-5,16.2-9.25,16.3-10.78s-1.82-3.23-1.48-4.92c.25-1.21,1.73-2.73,2.81-1.91,2,1.54,1.68,4.21,3.54,4,5.17-.62,10.83-4.34,11.33-6.16s3.85-1,4,2.71c.11,4.16,3.7,6.86,4,10.32"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 282,
    y: 44.31,
    width: 47.9,
    height: 2.36,
    transform: "translate(6.95 124.7) rotate(-23.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M305.3,33.83c0,1.3-5,4-8.4,5.69-2.43,1.24-5-.76-5-.76,6.17-3.67,11.34-6.62,11.42-7.84,0,0,2,1.61,2,2.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M313.44,37.23c1.82-3.2,3.71-6.5,10.61-9.86.12.3.25.6.39.89-6.61,3.23-8.42,6.39-10.16,9.45a23.38,23.38,0,0,1-2.74,4.09L309,42.92a17.54,17.54,0,0,0,4.49-5.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M287,41.75l.07,0,.75-.46c2.49,3.84,11.17,2.3,11.26,2.28l.17.95c-.4.07-9.44,1.67-12.25-2.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M353.85,52.39,306,53.89s-1-8.46,7.74-10c9.32-1.68,18.47-2.66,19.12-4.05s-.51-3.67.43-5.12c.67-1,2.61-1.91,3.31-.75,1.31,2.17,0,4.53,1.83,5,5,1.32,11.68-.07,12.81-1.57s3.94.49,2.68,4c-1.43,3.91.92,7.74,0,11.07"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 305.99,
    y: 53.14,
    width: 47.9,
    height: 2.36,
    transform: "translate(-1.54 10.33) rotate(-1.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M333.62,43.23c-.49,1.21-6.09,1.85-9.9,2.21-2.72.27-4.38-2.54-4.38-2.54,7.08-1.15,13-2,13.5-3.1,0,0,1.26,2.22.78,3.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M339.94,49.38c2.86-2.31,5.83-4.69,13.49-5.28q0,.48,0,1c-7.33.58-10.17,2.86-12.92,5.07a23,23,0,0,1-4.05,2.81l-2.81.08a17.33,17.33,0,0,0,6.26-3.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M313.64,43.87l.08,0,.86-.15c.92,4.48,9.55,6.23,9.65,6.25l-.19.94c-.4-.08-9.4-1.9-10.4-7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1317.12,
    y: 223.73,
    width: 53.22,
    height: 53.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M332.07,145.83A38.5,38.5,0,0,0,342,146s.71-16.88.8-19.81c.14-4.85,2.64-15.34,2.64-15.34s2.62,10,3.46,14.83c.78,4.37,1.77,20.71,1.77,20.71a33.58,33.58,0,0,0,9.67,0s-1.7-18.75-1.95-24.06c-.25-5.11-1.68-21.39-1.68-21.39H334.19s-1.88,17.74-1.88,23.44c0,6.7-.24,21.44-.24,21.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1442.6,
    y: 128.66,
    width: 121.62,
    height: 26.23,
    rx: 10.11
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-25",
    transform: "translate(1450.2 148.21)"
  }, "ADD TO CART"), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 835.66,
    cy: 72.47,
    r: 24.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 835.66,
    cy: 72.47,
    r: 21.08
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-27",
    transform: "translate(826.45 84.13)"
  }, "$"), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 517.52,
    cy: 267.92,
    r: 17.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 517.52,
    cy: 267.92,
    r: 15.2
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-28",
    transform: "translate(510.88 276.33)"
  }, "$"), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 497.66,
    cy: 78.45,
    r: 19.86
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-29",
    transform: "translate(486.22 88.58)"
  }, "%"), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1339.82,
    y: 223.73,
    width: 53.22,
    height: 53.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1319.17,
    y: 225.77,
    width: 49.13,
    height: 49.13
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "1387.89 275.1 1245.46 275.1 1221.98 182.23 1413.98 182.23 1387.89 275.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1249.11,
    y1: 182.23,
    x2: 1272.59,
    y2: 275.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1386.33,
    y1: 182.23,
    x2: 1360.5,
    y2: 275.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1356.02,
    y1: 182.23,
    x2: 1330.19,
    y2: 275.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1283.81,
    y1: 182.23,
    x2: 1305.72,
    y2: 275.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1317.98,
    y1: 275.1,
    x2: 1317.98,
    y2: 182.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1226.46,199.94c.18.74,182.55,0,182.55,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1233.27,
    y1: 226.9,
    x2: 1400.02,
    y2: 226.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 1239.84,
    y1: 252.87,
    x2: 1394.14,
    y2: 252.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1222,182.23s-6-29.37-25.3-24.41"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1165.11,
    y: 152.86,
    width: 31.57,
    height: 11.48,
    rx: 5.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1247.58,277.18a26.38,26.38,0,0,0,7.05,13.8c7.78,7.62,18.74,6.93,39.13,6.45,14.73-.34,29.48-.05,44.21-.39,11.41-.26,27.76-.37,47.74.39"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 1292.41,
    cy: 298.3,
    r: 10.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 1348.5,
    cy: 298.3,
    r: 10.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 1343.73,
    y: 52.41,
    width: 178.83,
    height: 16.71,
    rx: 7.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1507.71,
    cy: 58.6,
    r: 2.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-34",
    x1: 1508.84,
    y1: 60.75,
    x2: 1512.15,
    y2: 65.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 1118.73,
    y: 38.25,
    width: 114.7,
    height: 58.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 1204.94,
    cy: 84.19,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 1215.25,
    cy: 84.19,
    r: 7.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1127.38,
    y: 50.3,
    width: 62.67,
    height: 4.22,
    rx: 2.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1132.93,
    y: 84.19,
    width: 8.15,
    height: 6.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1144.08,
    y: 84.19,
    width: 8.15,
    height: 6.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1155.01,
    y: 84.19,
    width: 8.15,
    height: 6.16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECommerce6);
export default __webpack_public_path__ + "static/media/E-Commerce 6.6abb6144017e116c44fdb0776ff45916.svg";
export { ForwardRef as ReactComponent };